import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> =>
        import("./participant-session-attendance-modal-container.component").then(
            ({ ParticipantSessionAttendanceModalContainer: S }): { default: FC } => ({
                default: S
            })
        )
)

const Modal: FC = (): ReactElement => (
    <ModalContainer modalId={EModalId.Participant_SessionAttendance} container={Container} />
)

export { Modal as ParticipantSessionAttendanceModal }
